import { useFormContext } from "contexts/FormContext";
import React from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Image,
  Offcanvas,
  Row,
} from "react-bootstrap";
import { ArrowRightCircle, Recycle } from "react-bootstrap-icons";
import Select from "react-select";
import PlaceHolder from "assets/placeholder.webp";
import DefaultCurrency from "components/DefaultCurrency";
import CartItem from "./CartItem";

const Cart = ({ show, onHide, checkout }) => {
  // contexts
  const { formState, addDetail, setFormState } = useFormContext();

  return (
    <React.Fragment>
      <Offcanvas show={show} onHide={onHide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Order</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="pt-0">
          <Container fluid className="p-0">
            <Row>
              <Col
                xs={12}
                className="position-sticky top-0 bg-white pb-2 border-bottom shadow-sm"
                style={{ zIndex: 9 }}
              >
                <Select
                  required
                  value={formState.info.customer}
                  className="my-2"
                  placeholder="Select Customer..."
                  onChange={(e) => {
                    setFormState({
                      batch: [
                        { key: "info.customer", value: e },
                        { key: "info.customerEmail", value: null }
                      ]
                    });
                  }}
                  options={formState.customers?.map((x) => ({
                    value: x,
                    label: x.name,
                  }))}
                />
                <Row className="justify-content-between mt-4">
                  <h6 className="text-muted w-auto">Total Value:</h6>
                  <h6 className="w-auto">
                    <DefaultCurrency
                      value={formState.details.reduce(
                        (pre, cur) => pre + (parseFloat(cur.qty) || 0) * (parseFloat(cur.price) || 0),
                        0
                      )}
                    />
                  </h6>
                </Row>
                <Row className="justify-content-between">
                  <h6 className="text-muted w-auto">Total SKUs:</h6>
                  <h6 className="w-auto">
                    {
                      formState.details.reduce((pre, cur) => {
                        if (cur.item?.id && !pre.includes(cur.item.id))
                          pre.push(cur.item.id);
                        return pre;
                      }, []).length
                    }
                  </h6>
                </Row>
                <Row className="justify-content-between">
                  <h6 className="text-muted w-auto">Total Qty:</h6>
                  <h6 className="w-auto">
                    {formState.details.reduce(
                      (pre, cur) => pre + (parseFloat(cur.qty) || 0),
                      0
                    )}
                  </h6>
                </Row>
                <Row className="justify-content-end">
                  <Button className="w-auto mx-3" onClick={checkout}>
                    <span>Checkout</span>
                    <ArrowRightCircle size={20} className="mx-1" />
                  </Button>
                </Row>

                <Container className="position-sticky top-0">
                  {false && (
                    <Card className="mt-3">
                      <Card.Header>
                        <Card.Title>Recently Removed</Card.Title>
                      </Card.Header>
                      <Card.Body className="h-60vh overflow-scroll">
                        {formState.recentlyRemoved.map((x) => (
                          <React.Fragment key={x.uid}>
                            <Row className="my-1 py-2 border-bottom">
                              <Col sm={3}>
                                <Image
                                  src={x.item.image}
                                  onErrorCapture={({ currentTarget }) => {
                                    currentTarget.onerror = null; // prevents looping
                                    currentTarget.src = PlaceHolder;
                                  }}
                                  className="w-100"
                                />
                              </Col>
                              <Col sm={6}>
                                <h6>{x.item?.name}</h6>
                                <h6 className="m-0">
                                  Price: <DefaultCurrency value={x.price} />
                                </h6>
                                <h6 className="m-0">Qty: {x.qty}</h6>
                              </Col>
                              <Col
                                sm={3}
                                className="d-flex justify-content-center align-items-center"
                              >
                                <Button
                                  variant="success"
                                  onClick={() => addDetail(x)}
                                >
                                  <Recycle  size={16}/>
                                </Button>
                              </Col>
                            </Row>
                          </React.Fragment>
                        ))}
                      </Card.Body>
                    </Card>
                  )}
                </Container>
              </Col>
              <Col xs={12}>
                {!!formState.details.length &&
                  formState.details.map((cartItem, index) => (
                    <CartItem key={index} index={index} cartItem={cartItem} />
                  ))}

                {!formState.details.length && (
                  <p className="text-muted">No items in cart</p>
                )}
                <Button
                  onClick={() =>
                    addDetail({ item: {}, price: 0, qty: 0, extra: true })
                  }
                  className="mt-3"
                >
                  Add Item
                </Button>
              </Col>
            </Row>
          </Container>
        </Offcanvas.Body>
      </Offcanvas>
    </React.Fragment>
  );
};

export default Cart;
